import * as React from 'react';
import SummaryTimeline from '../../components/timelines/Summary'
import Log from '../../components/Log'
import { CommentCreateWidget } from './utils/CommentDialog'
import InstrumentStaticNotes from './utils/InstrumentStaticNotes'
import PartialHeaders from './utils/PartialHeaders'
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button'
import DiagnosisPlot from '../../components/DiagnosisPlot'
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import { Query } from 'react-apollo'
import {
    GET_INSTRUMENT_COMMENTS,
    GET_INSTRUMENT_DEPLOYMENTS,
    GET_INSTRUMENT_HARDWARESTATUS,
    GET_INSTRUMENT_ISSUES,
    GET_INSTRUMENT_STATI
} from '../../apollo/queries/instruments'

const formatInfoLogsDate = date => {
    const year = date.getFullYear()
    const month = `${date.getMonth() + 1}`.padStart(2, '0')
    const day = `${date.getDate()}`.padStart(2, '0')
    return `${year}${month}${day}`
}





class InstrumentDetail extends React.PureComponent {

    handleDataCheckerLink = () => {
        const { panId, deployment } = this.props.data;

        const locationName = deployment ? deployment[0].location.name : 'NoLocation';
        window.open(`https://datachecker.pandonia-global-network.org/Operational/P${panId}s1/${locationName}.html`, '_blank');
    };
    handleInstrumentDetailLink = () => {
        const { panId } = this.props.data;
        window.open(`https://hetzner.pandonia-global-network.org/instrument_details/${panId}`, '_blank');
    }
    handleInfoLogsLink = () => {
        const { panId } = this.props.data;
        const dateEnd = new Date()
        const dateIni = new Date(dateEnd)
        dateIni.setDate(dateEnd.getDate() - 3)
        const params = new URLSearchParams({
            instr_type: 'Pandora',
            pan_id: panId,
            date_ini: formatInfoLogsDate(dateIni),
            date_end: formatInfoLogsDate(dateEnd)
        })
        window.open(`https://infologs.pandonia-global-network.org/?${params.toString()}`, '_blank');
    }
  render() {
        return (
            <Paper style={{"flex": "1", "flexDirection": "column", "display": "flex"}}>
              <Query query={GET_INSTRUMENT_DEPLOYMENTS} variables={{input: this.props.data.id}} pollInterval={180000}>
                  {({loading: deploymentsLoading, error: deploymentsError, data: deploymentsData}) => {
                      if (deploymentsLoading) {
                          return <p>Loading deployments...</p>
                      }
                      if (deploymentsError) {
                          console.error("GET_INSTRUMENT_DEPLOYMENTS, error from instrument: ", deploymentsError.message)
                          return <p>Error loading deployments</p>
                      }

                      const deployment = deploymentsData && deploymentsData.instrument ? deploymentsData.instrument.deployment : []
                      const fullDeploymentData = {...this.props.data, deployment}

                      return (
                          <Query query={GET_INSTRUMENT_HARDWARESTATUS} variables={{input: fullDeploymentData.id}} pollInterval={180000}>
                              {({loading: hardwareLoading, error: hardwareError, data: hardwareData}) => {
                                  if (hardwareLoading) {
                                      return <p>Loading hardware status...</p>
                                  }
                                  if (hardwareError) {
                                      console.error("GET_INSTRUMENT_HARDWARESTATUS, error from instrument: ", hardwareError.message)
                                      return <p>Error loading hardware status</p>
                                  }

                                  const hardwarestatus = hardwareData && hardwareData.instrument ? hardwareData.instrument.hardwarestatus : []
                                  const fullData = {...fullDeploymentData, hardwarestatus}

                                  return (
                                      <Query query={GET_INSTRUMENT_STATI} variables={{input: fullData.id}} pollInterval={180000}>
                                          {({loading: statiLoading, error: statiError, data: statiData}) => {
                                              if (statiLoading) {
                                                  return <p>Loading status assignments...</p>
                                              }
                                              if (statiError) {
                                                  console.error("GET_INSTRUMENT_STATI, error from instrument: ", statiError.message)
                                                  return <p>Error loading status assignments</p>
                                              }

                                              const stati = statiData && statiData.instrument ? statiData.instrument.stati : []
                                              const fullStatiData = {...fullData, stati}

                                              return (
                                                  <React.Fragment>
                                                      <SummaryTimeline style={{margin: 'auto', marginBottom: '50'}} size={[1100,50]}
                                                                       data={fullStatiData} daysDelta={365} />
                                                      <div style={{flex: '1', display: "flex"}}>
                                                          <CommentCreateWidget user={this.props.user} panID={fullStatiData.panId} instrumentId={fullStatiData.id} />
                                                          <PartialHeaders panID={fullStatiData.panId} instrumentID={fullStatiData.id} />
                                                          { fullStatiData.deployment && fullStatiData.deployment[0] ?
                                                              <DiagnosisPlot panID={fullStatiData.panId} location={fullStatiData.deployment[0].location.name} /> :
                                                              null
                                                          }
                                                          <Button variant="outlined" onClick={this.handleDataCheckerLink} endIcon={<OpenInNewIcon />}>Data Checker</Button>
                                                          <Button variant="outlined" onClick={this.handleInstrumentDetailLink} endIcon={<OpenInNewIcon />}>Instrument Detail</Button>
                                                          <Button variant="outlined" onClick={this.handleInfoLogsLink} endIcon={<OpenInNewIcon />}>Info Logs</Button>

                                                      </div>
                                                      <InstrumentStaticNotes data={fullStatiData} user={this.props.user}/>
                                                      <Query query={GET_INSTRUMENT_COMMENTS} variables={{input: fullStatiData.id}} pollInterval={180000}>
                                                          {({loading: commentsLoading, error: commentsError, data: commentsData}) => {
                                                              if (commentsLoading) {
                                                                  return <p>Loading comments...</p>
                                                              }
                                                              if (commentsError) {
                                                                  console.error("GET_INSTRUMENT_COMMENTS, error from instrument: ", commentsError.message)
                                                                  return <p>Error loading comments</p>
                                                              }

                                                              const comments = commentsData && commentsData.instrument ? commentsData.instrument.comments : []
                                                              return (
                                                                  <Query query={GET_INSTRUMENT_ISSUES} variables={{input: fullStatiData.id}} pollInterval={180000}>
                                                                      {({loading: issuesLoading, error: issuesError, data: issuesData}) => {
                                                                          if (issuesLoading) {
                                                                              return <p>Loading issues...</p>
                                                                          }
                                                                          if (issuesError) {
                                                                              console.error("GET_INSTRUMENT_ISSUES, error from instrument: ", issuesError.message)
                                                                              return <p>Error loading issues</p>
                                                                          }

                                                                          const issues = issuesData && issuesData.instrument ? issuesData.instrument.issues : []
                                                                          return <Log data={{...fullStatiData, comments, issues}} user={this.props.user} />
                                                                      }}
                                                                  </Query>
                                                              )
                                                          }}
                                                      </Query>
                                                  </React.Fragment>
                                              )
                                          }}
                                      </Query>
                                  )
                              }}
                          </Query>
                      )
                  }}
              </Query>
            </Paper>
          );
  }
}

export default InstrumentDetail;
